import React, {
    Component,
    PropTypes
} from 'react';
import render from "react-dom";
import {
    Link
} from "react-router";
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import  {bumpUrl}from '../../../path.config'
import bumpService from 'SERVICES/purifier/bump/bumpService'
import SearchInput from 'CONFIG/component/search/searchInput'
import Tip from 'CONFIG/component/tip'
import ModalDel from 'CONFIG/component/ModalDel'
import BoxHeader from "CONFIG/component/boxHeader"
import ContentHeader from 'CONFIG/component/contentHeaderLeft'
import {language, resultTip, pageOption} from 'UTIL/common'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'

export default class PanalyzIndex extends Component {
    constructor(props) {
        super(props);
        this.onPageChange = this.onPageChange.bind(this);
        this.handle = this.handle.bind(this);
        this.delList = this.delList;
        this.del = this.del.bind(this);
        this.search = this.search.bind(this);
        this.state = {
            data: [],
            pageSize: 10,
            page: 1,
            total: 0,
            delRow: {},
            url: bumpUrl,
            msgTypes: {},
            pframeworkList: [],
        }
    };

    componentDidMount() {
        this.onPageChange(1, 10)
    }

    handle(cell, row) {
        const edit_url = "/config/panalyze/panalyzeEdit/" + row.id;
        return <div>
            <Link to={edit_url} className="btn btn-info btn-sm">{language()['edit']}</Link>&nbsp;&nbsp;
            <a className="btn btn-danger btn-sm" data-target="#delModal" data-toggle="modal"
               onClick={this.delList.bind(this, row.id, row.anName)}>{language()['delete']} </a>
        </div>;
    };

    delList(id, name, e) {
        const delList = {
            "id": id,
            "name": name
        };
        this.setState({
            delRow: delList,
        })
    }

    search() {
        this.onPageChange(1, 10)
    }

    del() {
        const id = this.state.delRow.id;
        bumpService.panalyzeDel(id).then(data => {
            this.onPageChange(1, 10);
            resultTip(data)
        })
    }

    onPageChange(page, sizePerPage, e) {
        var search = $.trim($("#search").val());
        const arr = {
            "page": page,
            "pageSize": sizePerPage,
            "search": search
        }
        var data = JSON.stringify(arr);
        bumpService.panalyzeList({data}).then(body => {
            console.log(body)
            const json = body.data;
            this.setState({
                data: json.analyzeList.records,
                total: json.analyzeList.total,
                msgTypes: json.msgTypes,
                pageSize: sizePerPage,
                page: page,
                pframeworkList: json.pframeworkList,
            })
        })

    }

    isSaveHis(cell, row) {
        var isSaveHis = '';
        if (row.isSaveHis == 1) {
            isSaveHis = language()['Yes'];
        }
        if (row.isSaveHis == 0) {
            isSaveHis = language()['No'];
        }
        return isSaveHis;
    }

    reset() {
        $("#search").val('');
        this.onPageChange(1, 10)
    }

    pframeworkId(cell, row) {
        var pframeworkName = '';
        var list = this.state.pframeworkList;
        for (let i in list) {
            if (row.pframeworkId == list[i].id) {
                pframeworkName = list[i].proName;
            }
        }
        return pframeworkName;
    }

    render() {
        let options = pageOption(this.state.page, this.state.pageSize);
        options['onPageChange'] = this.onPageChange.bind(this);
        var create_url = "/config/panalyze/panalyzeCreate";
        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['BasicConfiguration']}
                        <small>{language()['CommandAnalysis']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['CommandAnalysisList']}</h3>
                            <div style={{marginRight: "10px", float: "right"}}>
                                <Link to={create_url} className="btn btn-success btn-md">
                                    <i className="fa fa-plus-circle"></i> {language()['add']}
                                </Link>
                            </div>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className="title-box">
                                <div className="clearfix">
                                    <LongSearchInput id="search" name={language()['anName']}/>
                                    <button type="button" className="btn btn-info"
                                            onClick={this.search.bind(this)}>{language()['query']}</button>
                                    &nbsp;&nbsp;
                                    <button type="button" className="btn btn-warning" id="reset"
                                            onClick={this.reset.bind(this)}>
                                        {language()['resetting']}
                                    </button>
                                </div>
                            </div>
                            <div >
                                <BootstrapTable data={this.state.data} striped hover pagination={true} options={options}
                                                remote={true} fetchInfo={{dataTotalSize: this.state.total}}>
                                    <TableHeaderColumn isKey dataField='id' hidden={true}>ID </TableHeaderColumn>
                                    <TableHeaderColumn dataField='anName' width="150">{language()['anName']} </TableHeaderColumn>
                                    <TableHeaderColumn dataField='anCode' width="120">{language()['anCode']} </TableHeaderColumn>
                                    <TableHeaderColumn dataField='anValue' width="120">{language()['anValue']} </TableHeaderColumn>
                                    <TableHeaderColumn width="400"
                                        dataField='metaNames'>{language()['metaNames']} </TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={this.pframeworkId.bind(this)}
                                                       width="150">{language()['pframework']} </TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={this.isSaveHis.bind(this)}
                                                       width="100">{language()['isSaveHis']} </TableHeaderColumn>
                                    <TableHeaderColumn dataField='hisMsgType'
                                                       width="100">{language()['hisMsgType']} </TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={this.handle} width="150"
                                                       columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>
                    </div>
                </section>
                <ModalDel id="delModal" delModSure={this.del}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/bump/config/panalyze/panalyzeIndex.js